import React, {useState, useEffect} from 'react'
import Select from "react-select"
import axios from 'axios';
import cookie from 'react-cookies';
import {API_URL} from '../../../constants';

import $ from 'jquery';

function DatoAdicionalSelect(props) {

  const [loading, setloading] = useState(true);
  const [options, setoptions] = useState([]);

  const getData = () => {
      let actions = props.actions;

      let items = actions.map(item => {
        return {
          "label": item.label,
          "value": item.actionType
        }
      });

      let newItems = [];

      if(items.length > 0){
        items.map((item) => {
          let itemData = {};
          itemData.value = item.value;
          itemData.label = item.label;

          newItems.push(itemData);
        });
      }
      setoptions(newItems);
  }

  useEffect(() => {
    if(loading){
      getData();
    }
  }, [])

  const changeSelect = (val) => {
    if(props.onChange){
      if(val !== null){
        props.onChange(val);
      }else{
        props.onChange("");
      }
    }
  }
  
  return (
    <Select
        options={[...options]}
        onChange={(val) => changeSelect(val)}
        value={props.value}
        placeholder="Acción"
    />
  )
}

export default DatoAdicionalSelect